module.exports = __webpack_public_path__ + "media/pages/press/downloads/thumbnails/LifeTime_Logo_tn-84585d7f6cd0129e2e7e92fb81f19438.jpg";